import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';
import { PageTitle } from '../PageTitle';
import RoleForm from './role_form';
import { Message } from '../Message';
import { RolesService, GroupingsService, RoutesService } from '../../services';

@connect(state => {
  return {
    me: state.user.me,
    currentGrouping: state.currentGrouping.currentGrouping
  }
})
class RoleAdd extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      role: null,
      enterprise: this.props.me.enterprise,
      localErrorMessage: null,
      localSuccessMessage: null,
      allAvailableRoutes: null,
      adhocRoutes: [],
      templates: []
    };
  }

  componentDidMount() {
    GroupingsService.listAll().then(response => {
      this.setState({ deviceGroupings: response.groupings });
    }).catch(error => {
      console.error(error);
      this.state.localErrorHandler(error.message);
    })

    GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then(response => {
      this.setState({
        groupingFilterOptions: response.groupings
      });
    }).catch(error => {
      console.error(error);
      this.state.localErrorHandler(error.message);
    });

    RoutesService.listAll().then(response => {
      this.setState({
        allAvailableRoutes: response.routes.filter(uiRoute => uiRoute.parentTitle !== null)
      });
    }).catch((error) => {
      console.error(error);
      this.state.localErrorHandler(error.message);
    });
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleLocalSuccess(localSuccessMessage) {
    this.setState({ localSuccessMessage: localSuccessMessage });
  }

  messageDismissCallback() {
    this.setState({
      localErrorMessage: null,
      localSuccessMessage: null
    });
  }

  getGroupingMatchValue(newValue) {
    let curGrouping = this.findGrouping(newValue.value)
    let value = ''
    if (curGrouping.fullyQualifiedName.includes('.')) {
      if (curGrouping.deviceGroup.children.length > 0)
        value = curGrouping.fullyQualifiedName + "%"
      else
        value = curGrouping.fullyQualifiedName
    } else {
      value = '%'
    }
    return value
  }

  findGrouping(id) {
    for (let i = 0; i < this.state.deviceGroupings.length; i++) {
      if (this.state.deviceGroupings[i].id == id)
        return this.state.deviceGroupings[i]
    }
    return null
  }

  onRoutesChanged(adhocRoutes) {
    this.setState({ adhocRoutes: adhocRoutes });
  }

  onTemplatesChanged(templates) {
    this.setState({templates: templates});
  }

  handleSubmit({ name, token, description, deviceGroup, deviceGroupingMatch }) {
    const updatedRoles = this.state.adhocRoutes.map(uiRoute => {
      return { id: uiRoute.id };
    });

    const updatedTemplates =  this.state.templates.map(template => ({id: template.id}));

    const role = {
      name: name,
      roleType: this.props.location.roleType,
      description: description,
      enterprise: this.state.enterprise,
      deviceGroup: deviceGroup ? {id: deviceGroup.deviceGroup.id} : null,
      deviceGroupingMatch: deviceGroupingMatch ? this.getGroupingMatchValue(deviceGroupingMatch) : null,
      uiRoutes: updatedRoles,
      actionRoleTemplates: updatedTemplates
    };

    RolesService.add(role).then(response => {
      this.setState({ role: response.role });
    }).catch(error => {
      this.handleLocalError(i18next.t('messages.error-adding-role'));
      console.error(error);
    });
  }

  render() {
    if (this.state.role && this.props.location.roleType.token === 'action_role') {
      return ( <Redirect to={{ pathname: `/admin/roles/edit/${this.state.role.id}`, roleType: this.props.location.roleType, state: { from: this.props.location, successMessage: i18next.t('messages.role-saved') } }}/> );
    }

    if (this.state.role) {
      return ( <Redirect to={{ pathname: '/admin/roles', roleType: this.props.location.roleType, state: { from: this.props.location, successMessage: i18next.t('messages.role-saved') } }}/> );
    }

    if (!this.props.location.roleType) {
      return ( <Redirect to={{ pathname: '/admin/roles', state: { from: this.props.location } }}/> );
    }

    if (this.state.enterprise && this.state.groupingFilterOptions && this.state.deviceGroupings && this.state.allAvailableRoutes) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={i18next.t('pages.roles.add-role', {roleType: i18next.t(`role-types.${this.props.location.roleType.token}`)})}
                         backLinkWithParams= {{
                           link: {
                             pathname: "/admin/roles",
                             search: backLinkSearch,
                             roleType: this.props.location.roleType
                           }
                         }} />
            </div>

            <Message
                messages={{ state: { successMessage: this.state.localSuccessMessage } }}
                errorMessage={this.state.localErrorMessage}
                messageDismissCallback={this.messageDismissCallback.bind(this)}
            />

            <RoleForm
                groupingFilterOptions={this.state.groupingFilterOptions}
                allAvailableRoutes={this.state.allAvailableRoutes}
                onSubmit={this.handleSubmit.bind(this)}
                onRoutesChanged={this.onRoutesChanged.bind(this)}
                onTemplatesChanged={this.onTemplatesChanged.bind(this)}
                errorMessage={this.props.errorMessage}
                roleType={this.props.location.roleType}
                backLinkWithParams= {{
                  link: {
                    pathname: "/admin/roles",
                    search: backLinkSearch,
                    roleType: this.props.location.roleType
                  }
                }}
            />
          </div>
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

export default RoleAdd;
